// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section[data-v-0b62d3d8] {\n  padding-bottom: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
